import _ from 'lodash'
import type React from 'react'
import { forwardRef } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { twMerge } from 'tailwind-merge'

type Props = {
  className?: string
  label?: string | React.ReactNode
  name: string
  value?: string | number | undefined
  placeholder?: string
  maxLength?: number
  rows?: number
  maxRows?: number
  optional?: boolean
} & React.ComponentPropsWithoutRef<'textarea'>

export const Textarea = forwardRef<HTMLTextAreaElement, Props>((props: Props, ref: React.Ref<HTMLTextAreaElement>) => {
  const {
    className,
    label,
    name,
    value,
    placeholder,
    maxLength,
    rows,
    maxRows,
    optional,
    onChange,
    onBlur,
    onFocus,
    'aria-label': ariaLabel,
  } = props
  const errMsg = _.get(props, 'data-error')
  return (
    <div className='form-error w-full'>
      {label && (
        <label htmlFor={name} className='form-label'>
          {label}
          {optional && <span className='ml-1.5 font-light text-zinc-600 dark:text-zinc-400'>(optional)</span>}
        </label>
      )}
      <div className='form-container relative mt-1'>
        <TextareaAutosize
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          id={name}
          name={name}
          value={value}
          placeholder={placeholder || ''}
          maxLength={maxLength || undefined}
          minRows={rows || 4}
          maxRows={maxRows || 12}
          className={twMerge('form-textarea resize-y rounded', className)}
          aria-label={ariaLabel || (typeof label === 'string' ? label : name)}
          aria-invalid={!!errMsg}
          aria-errormessage={errMsg ? `${name}-error` : undefined}
        />
      </div>
      {errMsg && (
        <div id={`${name}-error`} className='form-error-message' role='alert'>
          {errMsg}
        </div>
      )}
    </div>
  )
})
